import script from "./EditAccessRequestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAccessRequestModal.vue?vue&type=script&setup=true&lang=js"

import "./EditAccessRequestModal.vue?vue&type=style&index=0&id=420486ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420486ed"]])

export default __exports__